module.exports = __webpack_public_path__ + "img/Accountor-04-lowres.de725636.jpg";